module.exports = __webpack_public_path__ + "static/media/sernice2.7855f556.png";